<template>
  <b-container style="margin-top:15px">
    <b-row>
      <b-card-group deck>
        <b-card header="Admin Ekle" header-tag="header">
            <b-row>
              <b-col cols="3">
                  <b-form-group label="İsim" :state="(!_.isUndefined(errors['name']) ? false : formPost)">
                    <b-form-input size="sm" v-model="form.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_name">
                    {{ _.first(errors['name']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Soyisim" :state="(!_.isUndefined(errors['surname']) ? false : formPost)">
                    <b-form-input size="sm" v-model="form.surname" placeholder="Soyisim"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_surname">
                    {{ _.first(errors['surname']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Firma" :state="(!_.isUndefined(errors['client_id']) ? false : formPost)">
                  <b-form-select size="sm" v-model="form.client_id" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                    <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                    <b-form-select-option :value="item.id" v-for="(item,key) in clients" :key="key">{{ item.title }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                  <b-form-invalid-feedback id="error_card_client_id">
                    {{ _.first(errors['client_id']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Email" :state="(!_.isUndefined(errors['email']) ? false : formPost)">
                    <b-form-input type="email" size="sm" v-model="form.email" placeholder="Email"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_email">
                    {{ _.first(errors['email']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Şifre" :state="(!_.isUndefined(errors['password']) ? false : formPost)">
                    <b-form-input type="password" size="sm" v-model="form.password" placeholder="Şifre"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_password">
                    {{ _.first(errors['password']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Telefon (Opsiyonel)" :state="(!_.isUndefined(errors['phone']) ? false : formPost)">
                    <b-form-input type="number" size="sm" v-model="form.phone" placeholder="Telefon"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_phone">
                    {{ _.first(errors['phone']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Dairesi (Opsiyonel)" :state="(!_.isUndefined(errors['tax']) ? false : formPost)">
                    <b-form-input size="sm" v-model="form.tax" placeholder="Vergi Dairesi"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_tax">
                    {{ _.first(errors['tax']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Numarası (Opsiyonel)" :state="(!_.isUndefined(errors['tax_number']) ? false : formPost)">
                    <b-form-input type="number" onKeyDown="if(this.value.length==10 && event.keyCode!=8) return false;"  size="sm" v-model="form.tax_number" placeholder="Vergi Numarası"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_tax_number">
                    {{ _.first(errors['tax_number']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Adres (Opsiyonel)" :state="(!_.isUndefined(errors['address']) ? false : formPost)">
                    <b-form-input size="sm" v-model="form.address" placeholder="Adres"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_address">
                    {{ _.first(errors['address']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="TC Kimlik Numarası (Opsiyonel)" :state="(!_.isUndefined(errors['identity_id']) ? false : formPost)">
                    <b-form-input type="number"  onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" size="sm" v-model="form.identity_id" placeholder="TC Kimlik Numarası"></b-form-input>
                  </b-form-group>
                  <b-form-invalid-feedback id="error_card_identity_id">
                    {{ _.first(errors['identity_id']) }}
                  </b-form-invalid-feedback>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Yetki Grubu">
                    <b-form-select size="sm" v-model="form.roles" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="item.id" v-for="(item,key) in roles" :key="key">{{ item.name }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Ekle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'AdminsCreate',
    data(){
      return{
        loading: false,
        clients:null,
        errors: {},
        formPost:null,
        roles:[],
        form:{
          name:null,
          surname:null,
          email:null,
          password:null,
          phone:null,
          tax:null,
          client_id:null,
          tax_number:null,
          address:null,
          identity_id:null, 
          roles: null,
        }
      }
    },
    created(){
      this.fetchRoles();
      this.fetchPayments();
    },
    methods:{
      fetchRoles(){
        axios.get('/admin/roles')
        .then((response) => {
            this.roles = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      fetchPayments(){
        axios.get('/list/clients')
        .then((response) => {
            this.clients = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      send(){
        this.loading = true;
        axios.post('/admin/create', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'warning', title: 'Ekleme Başarılı'});
            this.$router.push({name: 'Admins'});
        })
        .catch((err) => {
          this.formPost = true;
          this.errors = err.response.data.errors;
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>